var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isShowLoading)?_c('div',{staticClass:"first-loading-wrp"},[_vm._m(0)]):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrp"},[_c('span',{staticClass:"dot dot-spin"},[_c('i'),_c('i'),_c('i'),_c('i')])])
}]

export { render, staticRenderFns }